/**
 * Splits a walk's detections into the classes that can alert and the classes that cannot.
 *
 * The model also emits non-weapon classes (civilian, no_weapon) that carry high confidences of
 * their own, so the maximum is taken over the walk's configured weapon classes only.
 *
 * @param detections The walk's detections, most confident first.
 * @param weaponClasses The walk's visualThreatDetectionClasses.
 *
 * @return The grouped detections and the highest alertable confidence, null if there is none.
 */
const splitVisualDetections = (detections, weaponClasses) => {
  const allDetections = detections || [];
  const alertableClasses = weaponClasses || [];

  const alertable = allDetections.filter(detection =>
    alertableClasses.includes(detection.detectionClass)
  );
  const other = allDetections.filter(
    detection => !alertableClasses.includes(detection.detectionClass)
  );

  const confidences = alertable
    .map(detection => detection.confidence)
    .filter(confidence => confidence !== null && confidence !== undefined);

  return {
    alertable,
    other,
    maxConfidence: confidences.length ? Math.max(...confidences) : null
  };
};

export default splitVisualDetections;
